exports.getErrorMessage = function(err) {
  if(err?.response?.data?.message) {
    return err.response.data.message;
  }else if(err?.request?.data?.message) {
    return ("network error");
  }else {
    return err.message;
  }
}